import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export abstract class CountersService {
    abstract counter(key: string): Observable<number>;
}
